import { LensBoxMode, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { paiLensLayout } from '@upright/ui/common/upright/core/impact-lenses/pais/common/layout';
import { usePaiLensContext } from '@upright/ui/common/upright/core/impact-lenses/pais/common/use-pai-lens-context';
import { ElbowConnector } from '../../../impact-lens-profile/common/components/connectors/elbow-connector';
import { useCarouselLayout } from '../../../impact-lens-profile/context';
import { selectionStateToHighlightedImpact } from '../state';

export function PaiInfoBoxConnector() {
  const lensContext = usePaiLensContext();
  const baseLayout = useCarouselLayout();
  if (lensContext === undefined) {
    // TODO: Get rid of this, throw error instead
    /* eslint-disable @typescript-eslint/no-unsafe-argument */
    /* eslint-disable react-hooks/rules-of-hooks */
    return <></>;
  }
  const highlightedImpact = selectionStateToHighlightedImpact(lensContext.selectionState, baseLayout.boxMode);
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (baseLayout.boxMode === LensBoxMode.MODAL || !highlightedImpact) {
    return <></>;
  }
  const boxesArea = baseLayout.boxesArea(Side.LEFT);
  const pais = lensContext.data.pais;
  if (!pais) return <></>;

  const layout = paiLensLayout(baseLayout, pais);
  const countBoxesArea = layout.impactPaiCountBoxesArea(Side.LEFT, highlightedImpact);
  const x1 = boxesArea.x2;
  const y1 = boxesArea.cy;
  const x2 = countBoxesArea.x1;
  const y2 = countBoxesArea.cy;
  return <ElbowConnector x1={x1} x2={x2} y1={y1} y2={y2} />;
}
